"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeMergedTheme = void 0;
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const constants_1 = require("./constants");
const mergeBorderRadii_1 = require("./mergeBorderRadii");
const mergeColors_1 = require("./mergeColors");
const computeMergedTheme = (brandTheme) => {
    const { baseTheme: theme, overrides, palette } = brandTheme;
    const { config } = (0, cloneDeep_1.default)(constants_1.ALL_THEMES[theme]);
    return {
        borderRadius: (0, mergeBorderRadii_1.mergeBorderRadii)(config.borderRadius, overrides?.borderRadius ?? {}),
        colors: (0, mergeColors_1.mergeColors)(config.colors, overrides?.colors ?? {}, palette),
        font: constants_1.fontMap[theme][overrides?.font?.pairing ?? config.font.pairing],
        palette,
        theme,
    };
};
exports.computeMergedTheme = computeMergedTheme;
//# sourceMappingURL=computeMergedTheme.js.map